import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import moment from "moment";
import { Container } from "react-bootstrap";

import Header from "../App/Header/Header";
import SelectionsReview from "./SelectionsReview/SelectionsReview";
import CatalogueReview from "./CatalogueReview/CatalogueReview";

class Catalogue extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      filingDate: localStorage.getItem('synced_date') || moment.utc().subtract(1, "day").format("YYYY-MM-DD"),
      defaultSelection: "609a925cd40db", // Syndicated Loans
      title:""
    };
  }

  /* *** get current url ( below ) *** */
  getCurrentURL () {
    return window.location.href;
  }

  /* *** capitalize first letter in the string ( below ) *** */
  capitalizeFirstLetter(str) {
    const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalized;
  }

  /* *** dynamic page title according with url change ( below ) *** */
  pageTitle(){
   let url = new URL(this.getCurrentURL());
   let str = url.pathname.substring((url.pathname.indexOf("/")+1), url.pathname.length);
   return  this.capitalizeFirstLetter(str.substring(0, str.indexOf("/")));
  }

  componentDidMount(){
    this.setState({title: this.pageTitle()})
  }

  // componentDidUpdate(){
  //   this.setState({title: this.pageTitle()})
  // }

  render() {
    const {title} = this.state;
    return (
      <div>
        <Header user={this.props.user} title={title} />
        <Container className="MainContent">
          <Switch>
            <Route
              exact
              path="/catalogues"
              render={() => this.renderCatalogueDashboard()}
            />
            <Route
              exact
              path="/selections"
              render={() => this.renderSelectionDashboard()}
            />
            <Route
              exact
              path="/selections/show"
              render={(props) => this.renderOptimizedSelection({...this.props, props})}
            />
            <Route
              exact
              path="/catalogues/:filedAt/:inventory"
              component={(props) => (
                <CatalogueReview
                  {...this.props}
                  {...props}
                  filedAt={props.match.params.filedAt}
                  inventory={props.match.params.inventory}
                />
              )}
            />
            <Route
              exact
              path="/selections/:filedAt"
              component={(props) => this.renderSelectionParamDashboard({...this.props, props}) }
            />
          </Switch>
        </Container>
      </div>
    );
  }

  /* *** optimized cron Selection *** */
  renderOptimizedSelection(props){
    let filingDate = localStorage.getItem("filedAt");
    
    return (
      <SelectionsReview
        {...props}
        filedAt={filingDate}
        optimization={true}
      />)
  }

  renderSelectionParamDashboard(props){
    return (
      <SelectionsReview
        {...props}
        filedAt={props.match.params.filedAt}
        optimization={false}
      />
    )
  }

   renderCatalogueDashboard() {
    const { filingDate } = this.state;
    setTimeout(() => {
      this.setState({title: this.pageTitle()});
    }, 100);
    
    return <Redirect to={`/catalogues/${filingDate}/${this.state.defaultSelection}`} />;
  }

  renderSelectionDashboard() {
    const { filingDate } = this.state;
    setTimeout(() => {
      this.setState({title: this.pageTitle()});
    }, 100);
    return <Redirect to={`/selections/${filingDate}`} />;
  }
}

Catalogue.propTypes = {};

export default Catalogue;
